import { render, staticRenderFns } from "./DevDebug.vue?vue&type=template&id=0fa3b57f"
import script from "./DevDebug.vue?vue&type=script&lang=js"
export * from "./DevDebug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports